module.exports = __webpack_public_path__ + "static/media/grid1.d0a1e421.jpg";